import type { TranslationMessages } from "ra-core";

// Ukrainian translation of ra-core and ra-supabase UI strings.
// The published ra-language-ukrainian package targets react-admin v4 and is
// unmaintained, so the catalog lives here. Plural forms: one |||| few |||| many.
export const ukrainianRaMessages: TranslationMessages = {
  ra: {
    action: {
      add_filter: "Додати фільтр",
      add: "Додати",
      back: "Назад",
      bulk_actions:
        "Вибрано %{smart_count} елемент |||| Вибрано %{smart_count} елементи |||| Вибрано %{smart_count} елементів",
      cancel: "Скасувати",
      clear_array_input: "Очистити список",
      clear_input_value: "Очистити",
      clone: "Копіювати",
      confirm: "Підтвердити",
      create: "Створити",
      create_item: "Створити %{item}",
      delete: "Видалити",
      edit: "Редагувати",
      export: "Експорт",
      list: "Список",
      refresh: "Оновити",
      remove_filter: "Прибрати фільтр",
      remove_all_filters: "Прибрати всі фільтри",
      remove: "Прибрати",
      reset: "Скинути",
      save: "Зберегти",
      search: "Пошук",
      search_columns: "Пошук колонок",
      select_all: "Вибрати все",
      select_all_button: "Вибрати все",
      select_row: "Вибрати рядок",
      show: "Переглянути",
      sort: "Сортувати",
      undo: "Скасувати дію",
      unselect: "Зняти вибір",
      expand: "Розгорнути",
      close: "Закрити",
      open_menu: "Відкрити меню",
      close_menu: "Закрити меню",
      update: "Оновити",
      move_up: "Вище",
      move_down: "Нижче",
      open: "Відкрити",
      toggle_theme: "Світла / темна тема",
      select_columns: "Колонки",
      update_application: "Перезавантажити застосунок",
    },
    boolean: {
      true: "Так",
      false: "Ні",
      null: " ",
    },
    page: {
      create: "Створити: %{name}",
      dashboard: "Дашборд",
      edit: "%{name} %{recordRepresentation}",
      error: "Щось пішло не так",
      list: "%{name}",
      loading: "Завантаження",
      not_found: "Не знайдено",
      show: "%{name} %{recordRepresentation}",
      empty: "Тут поки порожньо: %{name}.",
      invite: "Додати перший запис?",
      access_denied: "Доступ заборонено",
      authentication_error: "Помилка авторизації",
    },
    input: {
      file: {
        upload_several:
          "Перетягніть файли сюди або натисніть, щоб вибрати файл.",
        upload_single: "Перетягніть файл сюди або натисніть, щоб вибрати.",
      },
      image: {
        upload_several:
          "Перетягніть зображення сюди або натисніть, щоб вибрати.",
        upload_single:
          "Перетягніть зображення сюди або натисніть, щоб вибрати.",
      },
      references: {
        all_missing: "Не вдалося знайти пов'язані дані.",
        many_missing: "Частина пов'язаних записів більше недоступна.",
        single_missing: "Пов'язаний запис більше недоступний.",
      },
      password: {
        toggle_visible: "Сховати пароль",
        toggle_hidden: "Показати пароль",
      },
    },
    message: {
      about: "Про систему",
      access_denied: "У вас немає прав для перегляду цієї сторінки",
      are_you_sure: "Ви впевнені?",
      authentication_error:
        "Сервер авторизації повернув помилку, дані входу не перевірено.",
      auth_error: "Помилка перевірки токена авторизації.",
      bulk_delete_content:
        "Видалити цей запис (%{name})? |||| Видалити ці %{smart_count} записи? |||| Видалити ці %{smart_count} записів?",
      bulk_delete_title:
        "Видалити %{name} |||| Видалити %{smart_count} записи |||| Видалити %{smart_count} записів",
      bulk_update_content:
        "Оновити %{name} %{recordRepresentation}? |||| Оновити ці %{smart_count} записи? |||| Оновити ці %{smart_count} записів?",
      bulk_update_title:
        "Оновити %{name} %{recordRepresentation} |||| Оновити %{smart_count} записи |||| Оновити %{smart_count} записів",
      clear_array_input: "Очистити весь список?",
      delete_content: "Видалити цей запис (%{name})?",
      delete_title: "Видалити %{name} %{recordRepresentation}",
      details: "Деталі",
      error: "Сталася помилка, запит не виконано.",
      invalid_form: "Форма заповнена з помилками. Перевірте поля",
      loading: "Зачекайте",
      no: "Ні",
      not_found: "Неправильна адреса або посилання.",
      select_all_limit_reached:
        "Елементів забагато, щоб вибрати всі. Вибрано перші %{max}.",
      unsaved_changes: "Частину змін не збережено. Вийти без збереження?",
      yes: "Так",
      placeholder_data_warning: "Проблема з мережею: дані не оновились.",
    },
    navigation: {
      clear_filters: "Скинути фільтри",
      no_filtered_results: "За цими фільтрами нічого не знайдено (%{name}).",
      no_results: "Нічого не знайдено (%{name})",
      no_more_results:
        "Сторінки %{page} не існує. Спробуйте попередню сторінку.",
      page_out_of_boundaries: "Сторінки %{page} не існує",
      page_out_from_end: "Це остання сторінка",
      page_out_from_begin: "Це перша сторінка",
      page_range_info: "%{offsetBegin}–%{offsetEnd} з %{total}",
      partial_page_range_info:
        "%{offsetBegin}–%{offsetEnd} з понад %{offsetEnd}",
      current_page: "Сторінка %{page}",
      page: "Перейти на сторінку %{page}",
      first: "Перша сторінка",
      last: "Остання сторінка",
      next: "Наступна сторінка",
      previous: "Попередня сторінка",
      page_rows_per_page: "Рядків на сторінці:",
      skip_nav: "Перейти до вмісту",
    },
    sort: {
      sort_by: "Сортувати за %{field_lower_first} %{order}",
      ASC: "за зростанням",
      DESC: "за спаданням",
    },
    auth: {
      auth_check_error: "Увійдіть, щоб продовжити",
      user_menu: "Профіль",
      username: "Логін",
      password: "Пароль",
      email: "Email",
      sign_in: "Увійти",
      sign_in_error: "Не вдалося увійти, спробуйте ще раз",
      logout: "Вийти",
    },
    notification: {
      updated:
        "Запис оновлено |||| Оновлено %{smart_count} записи |||| Оновлено %{smart_count} записів",
      created: "Запис створено",
      deleted:
        "Запис видалено |||| Видалено %{smart_count} записи |||| Видалено %{smart_count} записів",
      bad_item: "Некоректний запис",
      item_doesnt_exist: "Запис не існує",
      http_error: "Помилка зв'язку з сервером",
      data_provider_error: "Помилка даних. Деталі в консолі.",
      i18n_error: "Не вдалося завантажити переклад для цієї мови",
      canceled: "Дію скасовано",
      logged_out: "Сесія завершилась, увійдіть знову.",
      not_authorized: "У вас немає доступу до цього розділу.",
      application_update_available: "Доступна нова версія.",
      offline: "Немає зв'язку. Дані не завантажено.",
    },
    validation: {
      required: "Обов'язкове поле",
      minLength: "Щонайменше %{min} символів",
      maxLength: "Не більше %{max} символів",
      minValue: "Не менше %{min}",
      maxValue: "Не більше %{max}",
      number: "Має бути число",
      email: "Має бути коректний email",
      oneOf: "Має бути одне з: %{options}",
      regex: "Має відповідати формату: %{pattern}",
      unique: "Має бути унікальним",
    },
    saved_queries: {
      label: "Збережені запити",
      query_name: "Назва запиту",
      new_label: "Зберегти поточний запит...",
      new_dialog_title: "Зберегти поточний запит як",
      remove_label: "Видалити збережений запит",
      remove_label_with_name: "Видалити запит «%{name}»",
      remove_dialog_title: "Видалити збережений запит?",
      remove_message: "Видалити цей запит зі списку збережених?",
      help: "Відфільтруйте список і збережіть запит на потім",
    },
    guesser: {
      empty: {
        title: "Немає даних",
        message: "Перевірте джерело даних",
      },
    },
    configurable: {
      customize: "Налаштувати",
      configureMode: "Налаштувати сторінку",
      inspector: {
        title: "Інспектор",
        content: "Наведіть на елементи інтерфейсу, щоб налаштувати їх",
        reset: "Скинути налаштування",
        hideAll: "Сховати все",
        showAll: "Показати все",
      },
      Datagrid: {
        title: "Таблиця",
        unlabeled: "Колонка без назви #%{column}",
      },
      SimpleForm: {
        title: "Форма",
        unlabeled: "Поле без назви #%{input}",
      },
      SimpleList: {
        title: "Список",
        primaryText: "Основний текст",
        secondaryText: "Додатковий текст",
        tertiaryText: "Третій рядок",
      },
    },
  },
  "ra-supabase": {
    auth: {
      email: "Email",
      confirm_password: "Підтвердіть пароль",
      sign_in_with: "Увійти через %{provider}",
      forgot_password: "Забули пароль?",
      reset_password: "Скинути пароль",
      password_reset: "Перевірте пошту: ми надіслали лист для скидання пароля.",
      missing_tokens: "Відсутні токени доступу",
      back_to_login: "Назад до входу",
    },
    reset_password: {
      forgot_password: "Забули пароль?",
      forgot_password_details: "Введіть email, і ми надішлемо інструкції.",
    },
    set_password: {
      new_password: "Придумайте пароль",
    },
    validation: {
      password_mismatch: "Паролі не збігаються",
    },
    oauth: {
      authorize: "Дозволити доступ застосунку",
      authorize_details: "Цей застосунок просить доступ до вашого акаунта.",
      access_scope:
        "Він зможе читати й змінювати ваші дані з тими самими правами, що й у вашого акаунта.",
      approved: "Доступ дозволено",
      close_tab: "Цю вкладку можна закрити.",
      no_request: "Запит на авторизацію не знайдено",
    },
  },
};
